import React, { useCallback } from "react";
export const ClickAndPlayButton = ({ buttonIndex, buttonLabel, isActive, onClick }) => {
    const handleButtonClick = useCallback((event) => {
        onClick(event, buttonIndex);
    }, [buttonIndex, onClick]);
    return React.createElement("button", { className: isActive ? "active" : "", onClick: handleButtonClick }, buttonLabel);
};
